import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserDto } from 'shared';
import { NotificationService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';

@Component({
    selector: 'delete-user-dialog',
    templateUrl: './delete-user-dialog.component.html',
    styleUrls: ['./delete-user-dialog.component.scss'],
    standalone: false
})
export class DeleteUserDialogComponent implements OnInit {

  userDeleteForm!: UntypedFormGroup;
  userDto!:UserDto;
  userName!: string;

  constructor(private fb: UntypedFormBuilder,
    public translate: TranslateService,
    public dialogRef: MatDialogRef<DeleteUserDialogComponent>,
    private tenantService: TenantService,
    private notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.userDto = this.data.userDto;
    console.log("========================> userDto = ", this.userDto)
    // if (this.userDto.last_Name)
    //   this.userName = this.userDto.first_Name + " " + this.userDto.last_Name;
    // else
    //   this.userName = "";
    console.log("========================> userName = ", this.userDto.userName)
    this.userName = this.userDto.userName.trimLeft().trimRight();
    this.userDto.userName = (this.userName!="(not confirmed)")?this.userName:this.userDto.email;
    this.userName = (this.userName!="(not confirmed)")?this.userName:this.userDto.email;
    this.buildUserDeleteForm(this.userDto);
  }

  buildUserDeleteForm(userDto: UserDto) {
    this.userDeleteForm = this.fb.group({
      id:[userDto.id],
      userName:[this.userName]
    });
  }

  deleteUser(id: string) {
    if(this.userDeleteForm.valid){      
      // let db:string = this.tenantService.currentTenantName;
      // let dbId:string = this.tenantService.currentTenantId;

      // console.log("==============> remove user from tenant: dbId = ", dbId)

      // this.tenantService.deleteUser(db, dbId, this.userDto.id).subscribe({
      //   next:() => {
      //     this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERDELETED"]}`);
      //   },
      //   error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERUSERDELETEDERROR"]}`)
      // });

      this.dialogRef.close(this.userDeleteForm.value);
    }
  }

  cancel(){
    this.dialogRef.close();
  }
}
